/**
 * botStickyTarget — keep an AA target for a few ticks so bots do not flap (FID-BOT-26).
 *
 * Pure JS — no Three.js, no DOM.
 */

export const BOT_STICK_TICKS = 4;

export function stickCombatTarget(bot, nextTarget) {
  if (!bot) return nextTarget || null;
  const stuck = bot.stickyTarget;
  const ticks = Number(bot.stickyTicks) || 0;
  if (stuck && !stuck.isDead && ticks > 0) {
    bot.stickyTicks = ticks - 1;
    return stuck;
  }
  bot.stickyTarget = nextTarget || null;
  bot.stickyTicks = nextTarget ? BOT_STICK_TICKS : 0;
  return nextTarget || null;
}
